<template>
    <!-- 通知 -->
    <div class="">
      <v-dialog
      class="del"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        :height="274"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
        v-bind:confirmButtonText= "this.delete"
      >
        确定通知设备上报设备本地日志吗？
      </v-dialog>
    </div>
</template>

  <script>
  export default {
    components: {},
    props:{
      showInputDialog:{
        type:Boolean,
        default: false
      },
      product_key: {
      },
      device_key: {
      }
    },
    data() {
      return {
        delete:"确定",
        dialogTitle: "通知设备",
        isShow:false,
      };
    },
    created() {
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      handleConfirm() {
        const subData = {
          product_key: this.product_key,
          device_key: this.device_key,
        }
        this.$post(`/td/td-iot-api/iot/log/dev/local/post/notice/v1`, subData, false ).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.$message.success(res.msg);
          }
          else {
            this.$message.error(res.msg);
          }
        });
        this.$emit('update:showInputDialog',false)
      },
      handleAfterClose() {
        this.$emit('update:showInputDialog',false)
      },
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  </style>
